import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "left-filter-section" };
const _hoisted_2 = { class: "right-filter-section" };
import { ref } from 'vue';
import SubControllerTemplate from '@/templates/SubControllerTemplate.vue';
import { autoLcMemberCompanyInquiry } from '@/locales/ko/views/member_company_inquiry';
import Select from '@/components/Form/Select.vue';
import SearchInput from '@/components/Form/SearchInput.vue';
import SearchInputWrapper from '@/components/Form/SearchInputWrapper.vue';
import { findTypeOptions, keywordTypeOptions, } from '@/constants/memberCompanyInquiry/memberCompanyInquiryList';
import { pStore } from '@/pinia';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubController',
    setup(__props) {
        const lc = autoLcMemberCompanyInquiry();
        const pMemberCompanyInquiry = pStore.piniaMemberCompanyInquiry;
        // 초기 index 0으로 설정
        const searchFieldType = ref(keywordTypeOptions[0]?.value || 0);
        const findtype = ref(findTypeOptions[0]?.value || '');
        const searchQuery = ref('');
        /**
        * (게시물구분)셀렉트 변경시 핸들러
        */
        const handleChangFilterItem = (value) => {
            findtype.value = value;
            //  상태 업데이트
            pMemberCompanyInquiry.updateFilterOption({
                workerType: value,
            });
            // 새로운 데이터 로드
            pMemberCompanyInquiry.getFilteredData();
        };
        /**
        * (키워드검색)셀렉트 변경시 핸들러
        */
        const handleChangFieldType = (searchType) => {
            searchFieldType.value = searchType;
        };
        /**
         * 키워드 검색 엔터키 핸들러
         */
        const handleSearch = (searchText) => {
            if (!searchText) {
                console.warn('검색어가 비어있습니다.');
            }
            // Pinia 상태 업데이트 또는 검색 API 호출
            pMemberCompanyInquiry.updateFilterOption({
                searchType: searchFieldType.value,
                searchText,
            });
            pMemberCompanyInquiry.getFilteredData();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(SubControllerTemplate, null, {
                toolsSlot: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createCommentVNode("게시물 구분 "),
                        _createVNode(Select, {
                            width: 250,
                            title: _unref(lc)('post_category_title'),
                            items: _unref(findTypeOptions),
                            value: findtype.value,
                            "on-change": handleChangFilterItem
                        }, null, 8 /* PROPS */, ["title", "items", "value"])
                    ]),
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(SearchInputWrapper, null, {
                            default: _withCtx(() => [
                                _createVNode(Select, {
                                    items: _unref(keywordTypeOptions),
                                    value: searchFieldType.value,
                                    "on-change": handleChangFieldType
                                }, null, 8 /* PROPS */, ["items", "value"]),
                                _createVNode(SearchInput, {
                                    outlined: "",
                                    placeholder: _ctx.$t('common.input_field_placeholder', { field: _ctx.$t(`common.search_word`) }),
                                    value: searchQuery.value,
                                    "on-search": handleSearch
                                }, null, 8 /* PROPS */, ["placeholder", "value"])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _createCommentVNode(" <div class=\"right-filter-section\">\n        <Select\n          class=\"page-size-wrapper mini\"\n          :value=\"filterOption.pageSizeType\"\n          :items=\"pageSizeOptionList\"\n          :on-change=\"handleChangeSelect('pageSizeType')\"\n        ></Select>\n      </div> ")
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
